"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _Icon = _interopRequireDefault(require("../Icon"));

var _styling = require("../../toolkit/styling");

/* Lego Components */

/* Lego Toolkit */
var Chevron = function Chevron(props) {
  var className = props.className,
      style = props.style,
      direction = props.direction,
      _props$color = props.color,
      color = _props$color === void 0 ? "black" : _props$color;
  var styles = useStylesheet(props);
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: color == "black" ? "chevronRight" : "chevronRightWhite",
    className: (0, _styling.css)(styles.root, className, style),
    alt: "arrow ".concat(direction)
  });
};

var _default = Chevron;
exports["default"] = _default;

var useStylesheet = function useStylesheet(_ref) {
  var direction = _ref.direction;
  var transform = "";

  switch (direction) {
    case "up":
      transform = "rotate(270deg)";
      break;

    case "right":
      transform = "rotate(0deg)";
      break;

    case "down":
      transform = "rotate(90deg)";
      break;

    default:
      transform = "rotate(180deg)";
  }

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        transform: transform,
        transition: "all 0.2s linear"
      }
    });
  }, [transform]);
};